/* ============================================================================
   NeoSpherium — Instant Navigation (PROTOTYPE)
   1) Prefetch internal links on hover / focus / touch  -> next page is already
      in cache when the click lands, so navigation feels instant.
   2) Product-image morph: the clicked product-card image becomes the PDP lead
      image during a cross-document View Transition (the "shared element" feel).

   Safe by design:
     - same-origin links only; skips cart/account/admin, downloads, files,
       new-tab, nofollow, and [data-no-prefetch] links.
     - respects Save-Data and 2G connections (no prefetch).
     - prefetch (not prerender) -> no premature pixel/analytics firing (§5).
     - morph name is assigned only for the duration of the transition and
       cleared on finish, so it can never leak into the next navigation.
   Reversible — see ns-instant-nav.css header.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- 1. Prefetch ------------------------------------------------- */
  /* V2 (2026-07-02): browsers with Speculation Rules support get prerender/prefetch from
     ns-speculation-rules.liquid — the JS link-prefetch below would double-fetch there, so it
     now runs only as the fallback for non-supporting browsers (Safari/Firefox). */
  var specRules = !!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'));
  var prefetched = new Set();
  var conn = navigator.connection || {};
  var saveData = conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');

  function eligible(a) {
    if (!a || !a.href) return false;
    var url;
    try {
      url = new URL(a.href, location.href);
    } catch (e) {
      return false;
    }
    if (url.origin !== location.origin) return false;
    if (url.pathname === location.pathname && url.search === location.search) return false;
    if (a.hasAttribute('download')) return false;
    if (a.target && a.target !== '' && a.target !== '_self') return false;
    if ((a.getAttribute('rel') || '').indexOf('nofollow') !== -1) return false;
    if (a.hasAttribute('data-no-prefetch')) return false;
    if (/\/(cart|account|admin|checkout)(\/|$|\?)/.test(url.pathname)) return false;
    if (/\.(zip|pdf|jpe?g|png|webp|gif|mp4|mov|svg|json|js|css)$/i.test(url.pathname)) return false;
    if (prefetched.has(url.href)) return false;
    return true;
  }

  function prefetch(a) {
    if (specRules || saveData || !eligible(a)) return;
    var href = new URL(a.href, location.href).href;
    prefetched.add(href);
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    document.head.appendChild(link);
  }

  function linkFrom(e) {
    var t = e.target;
    return t && t.closest ? t.closest('a[href]') : null;
  }

  var hoverTimer;
  document.addEventListener('pointerover', function (e) {
    var a = linkFrom(e);
    if (!a) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { prefetch(a); }, 60);
  }, { passive: true });

  document.addEventListener('pointerout', function () {
    clearTimeout(hoverTimer);
  }, { passive: true });

  document.addEventListener('focusin', function (e) {
    var a = linkFrom(e);
    if (a) prefetch(a);
  });

  document.addEventListener('touchstart', function (e) {
    var a = linkFrom(e);
    if (a) prefetch(a);
  }, { passive: true });

  /* ---------- 2. Product-image morph ------------------------------------- */
  if (!('startViewTransition' in document)) return;

  var VT_NAME = 'ns-product-hero';
  var FLAG = 'nsVtProductMorph';
  var clickedImg = null;

  /* District-card -> District-page hero morph (Tier 3): the homepage "Enter the
     District" card image expands into the immersive District page hero. */
  var DISTRICT_VT = 'ns-district-hero';
  var DISTRICT_FLAG = 'nsVtDistrictMorph';
  var clickedDistrictBg = null;

  function clearName(el) {
    if (el) el.style.viewTransitionName = '';
  }

  /* capture phase so we record the image even if the card stops propagation */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href*="/products/"]') : null;
    clickedImg = a ? a.querySelector('img') : null;
    /* District card: the "Enter the District" link -> /pages/districts-<handle> */
    clickedDistrictBg = null;
    var da = t && t.closest ? t.closest('a[href*="/pages/districts-"]') : null;
    if (da) {
      var card = da.closest('.district');
      if (card) clickedDistrictBg = card.querySelector('.district__bg');
    }
  }, true);

  /* OLD page: prep the outgoing snapshot before it is swapped out */
  window.addEventListener('pageswap', function (e) {
    if (!e.viewTransition) return;
    /* keep the header captured in its visible state so it stays pinned */
    var navEl = document.getElementById('nav');
    if (navEl) navEl.classList.remove('nav--hidden');
    /* morph: tag the clicked product-card image */
    if (clickedImg && document.contains(clickedImg)) {
      clickedImg.style.viewTransitionName = VT_NAME;
      try { sessionStorage.setItem(FLAG, '1'); } catch (err) {}
      var img = clickedImg;
      e.viewTransition.finished.finally(function () { clearName(img); });
    }
    /* morph: tag the clicked District card background */
    if (clickedDistrictBg && document.contains(clickedDistrictBg)) {
      clickedDistrictBg.style.viewTransitionName = DISTRICT_VT;
      try { sessionStorage.setItem(DISTRICT_FLAG, '1'); } catch (err) {}
      var dbg = clickedDistrictBg;
      e.viewTransition.finished.finally(function () { clearName(dbg); });
    }
  });

  /* NEW-page (pagereveal) handling moved to an INLINE head script in theme.liquid
     (V1 2026-07-02): pagereveal fires at the new document's first render opportunity,
     which can precede this deferred file's execution — a deferred listener misses the
     event and the morph never completes on the arrival side. The pageswap side stays
     here (the OLD page has long finished loading, so the deferred listener is safe).
     The directional back/forward tagging died with the deleted root-slide CSS. */
})();
